<script lang="ts" setup>
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { bsAlert } from '@shared/components/BsAlerts';
    import { inject, onMounted } from 'vue';
    import SegmentGroup from './SegmentEditor/SegmentTypes/SegmentGroup.vue';
    import { collectIsValid, setIsNewToFalse } from './SegmentEditor/SegmentValidators/utils';
    import { SegmentAccess } from './Segments.access';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const segmentAccess: SegmentAccess = injectorAccess.injector.get(SegmentAccess);

    const props = defineProps<{
        segment: { segmentId: KnockoutObservable<string>; beforeSave: { [key: string]: () => boolean } };
    }>();

    onMounted(async () => {
        if (segmentAccess?.state?.segmentId !== props.segment.segmentId()) {
            await segmentAccess.init(props.segment.segmentId()).then(() => {});
            props.segment.beforeSave['segment'] = () => {
                if (!segmentAccess.state.segment?.SegmentDefinition?.Segments?.length) {
                    props.segment.segmentId('');
                }
                let success = false;
                setIsNewToFalse(segmentAccess.state.segment?.SegmentDefinition);
                const isInvalid = collectIsValid(segmentAccess.state.segment?.SegmentDefinition).includes(false);
                const alertSuccess = false;
                if (!isInvalid) {
                    segmentAccess.save(alertSuccess);
                    success = true;
                } else {
                    bsAlert({ title: $Resources.ErrorHeading, content: $Resources.ErrorSegmentFilterInvalidProperty, type: 'danger' });
                }
                return success;
            };
        }
    });
</script>

<template>
    <SegmentGroup
        v-if="segmentAccess.state.segment && segmentAccess.state.segment.SegmentDefinition?.DragAndDropId"
        :segment="segmentAccess.state.segment"
        :segment-group="segmentAccess.state.segment.SegmentDefinition"
        :root="true"></SegmentGroup>
</template>
